export default __webpack_public_path__ + "static/media/backoffice-dashboard.9e98f380.jpg";